import "../../../../js/organism/newsletterSubscription";

if (Domestika) {
  Domestika.courses.handle_course_card();
  Domestika.highlight_hash_element.handle();
  Domestika.timeago.handle();
  Domestika.sticky.stick_in_parent(".js-sticky-area", ".blog-post-detail");
  Domestika.gtm_tracking.handle_course_tracking();
  Domestika.video_attachable.make_embed_videos_clickable();
  Domestika.mentionable.handle();
  Domestika.textarea_autosize.handle();
  Domestika.event_tracking.handle_blog_post_tracking();
  Domestika.textarea_reply.handle();
  Domestika.bb_editor.handle();
  document.querySelector(".js-selectable");

  const { blogPostId, blogPostControlsUrl, commentsControlsUrl } = document.querySelector(
    ".js-blog-post-detail"
  )?.dataset;

  if (blogPostControlsUrl) {
    Domestika.commentable.display_blog_post_controls(blogPostId, blogPostControlsUrl);
  }
  if (commentsControlsUrl) {
    Domestika.commentable.display_blog_post_comments_controls(commentsControlsUrl);
  }
}
